import { config } from '@/config/env';

/**
 * Utilidades para generar links públicos de candidatos usando token seguro
 * (firmado y con expiración en backend).
 */

const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCandidateRegistrationToken = async (
  jobRequestId: string | number,
): Promise<{ token: string; expiresAt: string }> => {
  const response = await fetch(
    `${config.apiBaseUrl}/job-requests/${jobRequestId}/public-link-token`,
    {
      headers: getAuthHeaders(),
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || 'No se pudo generar el token de enlace público',
    );
  }

  return response.json();
};

export const generateCandidateRegistrationLink = async (
  jobRequestId: string | number,
  baseUrl?: string,
): Promise<string> => {
  const host = baseUrl || window.location.origin;
  const { token } = await getCandidateRegistrationToken(jobRequestId);
  return `${host}/candidato/registro?token=${encodeURIComponent(token)}`;
};

// Función para copiar el link al portapapeles
export const copyLinkToClipboard = async (link: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(link);
      return true;
    } else {
      // Fallback para navegadores que no soportan la Clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = link;
      textArea.style.position = 'absolute';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    }
  } catch (error) {
    console.error('Error copiando al portapapeles:', error);
    return false;
  }
};
